import React from "react"

import { DEFAULT_LOCALE } from "../../utils/locales"
import { TREMENDOUS_MARKETING_URL } from "../../utils/urls"

type Props = {
  pathname: string
  locale: string
}

export function HreflangTag({ pathname, locale }: Props) {
  return (
    <link
      rel="alternate"
      href={TREMENDOUS_MARKETING_URL + pathname}
      hrefLang={locale === DEFAULT_LOCALE ? "x-default" : locale}
    />
  )
}
